export default __webpack_public_path__ + "static/afiU-logo-horizontal-en-033e3b51878c723f9d99625c47cdd434.png";